import styled, { keyframes } from 'styled-components';

const flash = keyframes`
  0% {
    background: #f3f3f3;
}
  50% {
    background: #f9f9f9;
}
  100% {
    background: #f3f3f3;
}
`;

export const CalendarWorklogContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  position: relative;
  flex: 0 0 64px;
  border-radius: 3px;
  border: 1px solid #e1e1e1;
  background: white;
  width: calc(100% - 14px);
  margin: 6px;
  height: 56px;
  cursor: pointer;
`;

export const CalendarWorklogBody = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
`;

export const CalendarWorklogBodyLeft = styled.div`
  flex: 1 1 100%;
  padding: 5px;
  display: flex;
  flex-flow: column nowrap;
`;

export const CalendarWorklogBodyRight = styled.div`
  display: flex;
  flex-flow: column nowrap;
  background: #f9f9f9;
  padding: 3px 5px 5px 5px;
  justify-content: center;
  align-items: center;
  border-left: 1px solid #e1e1e1;
  > div:first-child {
    align-self: flex-start;
    margin-bottom: auto;
  }
`;

export const IssueKey = styled.div`
  border-radius: 2px;
  margin: .1rem 0;
  flex: 1 1 0%;
  background: #f3f3f3;
  animation: ${flash} 1s infinite;
`;
export const WorklogInfo = styled.div`
  flex-grow: 1;
  align-self: center;
  margin: .1rem 0;
  width: 50%;
  background: #f3f3f3;
  animation: ${flash} 1s infinite;
`;

export const Avatar = styled.div`
    width: 24px;
    height: 24px;
    line-height: 24px;
    border: 1px solid #e1e1e1;
    border-radius: 50%;
`;
